import { SET_APP_STATE, CLEAR_APP_STATE } from "./navigationActionTypes";

// Save Redux state + sessionStorage
export const setNavigationState = (data) => {
  const payload = {
    ...data,
    page: window.location.pathname, // store the page where data should apply
  };

  sessionStorage.setItem("appState", JSON.stringify(payload));

  return {
    type: SET_APP_STATE,
    payload,
  };
};

// Clear Redux state + sessionStorage
export const clearNavigationState = () => {
  sessionStorage.removeItem("appState");

  return {
    type: CLEAR_APP_STATE,
  };
};

// Redirect & store the state
export const redirectWithState = (data, url) => {
  // --- Flexible input handling ---
  // Case 1: redirectWithState("/target")
  if (typeof data === "string" && !url) {
    url = data;
    data = {}; // no state provided
  }

  // --- Default safe state ---
  const safeData = {
    source: null,
    values: {},
    redirectTo: null,
    ...(data || {}),
  };

  return (dispatch) => {

    const payload = {
      ...safeData,
      page: url, // Track where this navigation is intended for
    };

    // Save to sessionStorage
    sessionStorage.setItem("appState", JSON.stringify(payload));

    // Save to Redux
    dispatch({ type: SET_APP_STATE, payload });

    // Redirect
    if (url) window.location.href = url;
  };
};
